

import React, { memo, useState } from 'react';
import _omit from 'lodash.omit';
import AddNewItem from '../../AddNewItem';
import MultipleDropdownItem from './MultipleDropdownItem';
import { isInvalidAddon, generateAddonId } from '../../../../../utils';
import '../../../styles/_multiple-dropdown.scss';










function onChangeValue({ index, option, selectedValues, setSelectedValues, onChange }) {
  const updatedValues = selectedValues.map((selectedValue) => _omit(selectedValue, ['disabled']));

  updatedValues.splice(index, 1, option);
  setSelectedValues(updatedValues);

  onChange(updatedValues.filter((updatedValue) => !isInvalidAddon(updatedValue)));
}

function onDeleteValue({ index, selectedValues, setSelectedValues, onChange }) {
  const updatedValues = [...selectedValues];

  updatedValues.splice(index, 1);
  setSelectedValues(updatedValues);
  onChange(updatedValues);
}

function addNewItem(selectedValues, setSelectedValues) {
  const newValues = [...selectedValues, { value: null, addonId: generateAddonId() }];

  setSelectedValues(newValues);
}

function MultipleDropdown({
  defaultValues,
  onChange,
  addItemLabel = 'Add item',
  placeholder,
  disabled,
  options
}) {
  const initialValues = defaultValues ? defaultValues.map((value) => ({ ...value, disabled })) : [];

  const [selectedValues, setSelectedValues] = useState(initialValues);

  return (
    <div className="multiple-dropdown">
      <div>
        {
        selectedValues.map((selectedValue, index) =>
        <MultipleDropdownItem
          defaultValue={selectedValue}
          onChange={(option) => onChangeValue({
            index,
            option,
            selectedValues,
            setSelectedValues,
            onChange
          })}
          placeholder={placeholder}
          disabled={selectedValue.disabled}
          options={options}
          selectedValues={selectedValues}
          onDelete={() => onDeleteValue({ index, selectedValues, setSelectedValues, onChange })}
          index={index}
          key={selectedValue.addonId || selectedValue.value} />

        )}


      </div>
      <div className="multiple-dropdown__add-btn">
        <AddNewItem
          label={addItemLabel}
          addNewItem={() => addNewItem(selectedValues, setSelectedValues)} />

      </div>
    </div>);

}

export default memo(MultipleDropdown);